import PropTypes from 'prop-types';
import React from 'react';

import { abreviarNumero } from '../../../../helpers/formatador';
import useCardData from '../hooks/useCardData';
import Card from './Cards';
import { CardContainer } from './styles';

const CardsGrid = ({ clientes }) => {
  const { cardData, loadingCardData } = useCardData({
    clientes,
  });

  return (
    <CardContainer>
      <Card
        title="Quantidade de transportadoras"
        content={
          cardData?.transportadorasTotal
            ? abreviarNumero(cardData.transportadorasTotal)
            : '0'
        }
        loading={loadingCardData}
      />
      <Card
        title="Transportadoras ativas"
        content={
          cardData?.transportadorasAtivas
            ? abreviarNumero(cardData.transportadorasAtivas)
            : '0'
        }
        loading={loadingCardData}
      />
      <Card
        title="Transportadoras inativas"
        content={
          cardData?.transportadorasInativas
            ? abreviarNumero(cardData.transportadorasInativas)
            : '0'
        }
        loading={loadingCardData}
      />
    </CardContainer>
  );
};

CardsGrid.propTypes = {
  clientes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default CardsGrid;
